const state = {
    currentUser: {}
};

const mutations = {
    SET_CURRENT_USER: (state, info) => {
        state.currentUser = info;
    }
};

const actions = {
    setCurrentUser({ commit }, info) {
        commit("SET_CURRENT_USER", info);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/current_user.js